import { render, staticRenderFns } from "./uploadSentencePage.vue?vue&type=template&id=10592cdc&"
import script from "./uploadSentencePage.vue?vue&type=script&lang=js&"
export * from "./uploadSentencePage.vue?vue&type=script&lang=js&"
import style0 from "./uploadSentencePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports